// source: witbooking/loyalty/customer/v1/customer_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js');
goog.object.extend(proto, witbooking_backoffice_common_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_type_money_pb = require('../../../../google/type/money_pb.js');
goog.object.extend(proto, google_type_money_pb);
var witbooking_loyalty_shared_tier_pb = require('../../../../witbooking/loyalty/shared/tier_pb.js');
goog.object.extend(proto, witbooking_loyalty_shared_tier_pb);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.CreateCustomerRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.CreateCustomerResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.Customer', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.CustomerOrganization', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.CustomerPreference', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.CustomerTransactionData', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.GetCustomerRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.GetCustomerResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.ListCustomersRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.ListCustomersResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.OrganizationType', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.Status', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.TierType', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.GetCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.GetCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.GetCustomerRequest.displayName = 'proto.witbooking.loyalty.customer.v1.GetCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.GetCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.GetCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.GetCustomerResponse.displayName = 'proto.witbooking.loyalty.customer.v1.GetCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.displayName = 'proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.displayName = 'proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.displayName = 'proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.displayName = 'proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.ListCustomersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.ListCustomersRequest.displayName = 'proto.witbooking.loyalty.customer.v1.ListCustomersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.customer.v1.ListCustomersResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.ListCustomersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.ListCustomersResponse.displayName = 'proto.witbooking.loyalty.customer.v1.ListCustomersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.CreateCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.displayName = 'proto.witbooking.loyalty.customer.v1.CreateCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.CreateCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.displayName = 'proto.witbooking.loyalty.customer.v1.CreateCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.displayName = 'proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.displayName = 'proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.displayName = 'proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.displayName = 'proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.displayName = 'proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.displayName = 'proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.displayName = 'proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.displayName = 'proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.displayName = 'proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.displayName = 'proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.displayName = 'proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.displayName = 'proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.displayName = 'proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.displayName = 'proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.displayName = 'proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.displayName = 'proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.displayName = 'proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.displayName = 'proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest.displayName = 'proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.displayName = 'proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.Customer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.customer.v1.Customer.repeatedFields_, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.Customer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.Customer.displayName = 'proto.witbooking.loyalty.customer.v1.Customer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.CustomerOrganization, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.CustomerOrganization.displayName = 'proto.witbooking.loyalty.customer.v1.CustomerOrganization';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.CustomerTransactionData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.CustomerTransactionData.displayName = 'proto.witbooking.loyalty.customer.v1.CustomerTransactionData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.customer.v1.CustomerPreference = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.customer.v1.CustomerPreference, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.customer.v1.CustomerPreference.displayName = 'proto.witbooking.loyalty.customer.v1.CustomerPreference';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.GetCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.GetCustomerRequest;
  return proto.witbooking.loyalty.customer.v1.GetCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.GetCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.GetCustomerRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.GetCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    customer: (f = msg.getCustomer()) && proto.witbooking.loyalty.customer.v1.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.GetCustomerResponse;
  return proto.witbooking.loyalty.customer.v1.GetCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.customer.v1.Customer;
      reader.readMessage(value,proto.witbooking.loyalty.customer.v1.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.GetCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.customer.v1.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Customer customer = 1;
 * @return {?proto.witbooking.loyalty.customer.v1.Customer}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerResponse.prototype.getCustomer = function() {
  return /** @type{?proto.witbooking.loyalty.customer.v1.Customer} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.customer.v1.Customer, 1));
};


/**
 * @param {?proto.witbooking.loyalty.customer.v1.Customer|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerResponse} returns this
*/
proto.witbooking.loyalty.customer.v1.GetCustomerResponse.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.GetCustomerResponse.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerResponse.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest;
  return proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    customer: (f = msg.getCustomer()) && proto.witbooking.loyalty.customer.v1.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse;
  return proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.customer.v1.Customer;
      reader.readMessage(value,proto.witbooking.loyalty.customer.v1.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.customer.v1.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Customer customer = 1;
 * @return {?proto.witbooking.loyalty.customer.v1.Customer}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.prototype.getCustomer = function() {
  return /** @type{?proto.witbooking.loyalty.customer.v1.Customer} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.customer.v1.Customer, 1));
};


/**
 * @param {?proto.witbooking.loyalty.customer.v1.Customer|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse} returns this
*/
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest;
  return proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string customer_id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    customer: (f = msg.getCustomer()) && proto.witbooking.loyalty.customer.v1.Customer.toObject(includeInstance, f),
    customerJwt: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse;
  return proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.customer.v1.Customer;
      reader.readMessage(value,proto.witbooking.loyalty.customer.v1.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerJwt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.customer.v1.Customer.serializeBinaryToWriter
    );
  }
  f = message.getCustomerJwt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Customer customer = 1;
 * @return {?proto.witbooking.loyalty.customer.v1.Customer}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.prototype.getCustomer = function() {
  return /** @type{?proto.witbooking.loyalty.customer.v1.Customer} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.customer.v1.Customer, 1));
};


/**
 * @param {?proto.witbooking.loyalty.customer.v1.Customer|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse} returns this
*/
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string customer_jwt = 2;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.prototype.getCustomerJwt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.prototype.setCustomerJwt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.ListCustomersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    brandId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    filtersMap: (f = msg.getFiltersMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.ListCustomersRequest;
  return proto.witbooking.loyalty.customer.v1.ListCustomersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    case 4:
      var value = msg.getFiltersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.ListCustomersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFiltersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional int32 page_size = 1;
 * @return {number}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string brand_id = 3;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, string> filters = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.prototype.getFiltersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.ListCustomersRequest.prototype.clearFiltersMap = function() {
  this.getFiltersMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.ListCustomersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    totalElements: jspb.Message.getFieldWithDefault(msg, 2, 0),
    totalPages: jspb.Message.getFieldWithDefault(msg, 3, 0),
    first: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    last: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 6, 0),
    customersList: jspb.Message.toObjectList(msg.getCustomersList(),
    proto.witbooking.loyalty.customer.v1.Customer.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.ListCustomersResponse;
  return proto.witbooking.loyalty.customer.v1.ListCustomersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalElements(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPages(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFirst(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLast(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 7:
      var value = new proto.witbooking.loyalty.customer.v1.Customer;
      reader.readMessage(value,proto.witbooking.loyalty.customer.v1.Customer.deserializeBinaryFromReader);
      msg.addCustomers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.ListCustomersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalElements();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTotalPages();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFirst();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getLast();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getCustomersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.witbooking.loyalty.customer.v1.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 page_size = 1;
 * @return {number}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 total_elements = 2;
 * @return {number}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.getTotalElements = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.setTotalElements = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 total_pages = 3;
 * @return {number}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.getTotalPages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.setTotalPages = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool first = 4;
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.getFirst = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.setFirst = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool last = 5;
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.getLast = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.setLast = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int32 page_number = 6;
 * @return {number}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated Customer customers = 7;
 * @return {!Array<!proto.witbooking.loyalty.customer.v1.Customer>}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.getCustomersList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.customer.v1.Customer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.loyalty.customer.v1.Customer, 7));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.customer.v1.Customer>} value
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse} returns this
*/
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.setCustomersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.Customer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.customer.v1.Customer}
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.addCustomers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.witbooking.loyalty.customer.v1.Customer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.customer.v1.ListCustomersResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.ListCustomersResponse.prototype.clearCustomersList = function() {
  return this.setCustomersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.CreateCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customer: (f = msg.getCustomer()) && proto.witbooking.loyalty.customer.v1.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.CreateCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.CreateCustomerRequest;
  return proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.CreateCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.CreateCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.customer.v1.Customer;
      reader.readMessage(value,proto.witbooking.loyalty.customer.v1.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.CreateCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.customer.v1.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Customer customer = 1;
 * @return {?proto.witbooking.loyalty.customer.v1.Customer}
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.prototype.getCustomer = function() {
  return /** @type{?proto.witbooking.loyalty.customer.v1.Customer} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.customer.v1.Customer, 1));
};


/**
 * @param {?proto.witbooking.loyalty.customer.v1.Customer|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.CreateCustomerRequest} returns this
*/
proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.CreateCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerRequest.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.CreateCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.CreateCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.CreateCustomerResponse;
  return proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.CreateCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.CreateCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.CreateCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    authenticationServiceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    brandId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    emailAddress: jspb.Message.getFieldWithDefault(msg, 6, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
    birthDate: (f = msg.getBirthDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    location: (f = msg.getLocation()) && witbooking_backoffice_common_common_pb.Localizable.toObject(includeInstance, f),
    referrer: jspb.Message.getFieldWithDefault(msg, 10, ""),
    loyaltyPoints: jspb.Message.getFieldWithDefault(msg, 11, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
    legalidentifier: jspb.Message.getFieldWithDefault(msg, 14, ""),
    tierId: jspb.Message.getFieldWithDefault(msg, 15, ""),
    status: jspb.Message.getFieldWithDefault(msg, 16, 0),
    communicationConsent: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
    locale: jspb.Message.getFieldWithDefault(msg, 18, ""),
    createdByBookAndJoin: jspb.Message.getBooleanFieldWithDefault(msg, 19, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest;
  return proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthenticationServiceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailAddress(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBirthDate(value);
      break;
    case 9:
      var value = new witbooking_backoffice_common_common_pb.Localizable;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Localizable.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferrer(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLoyaltyPoints(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegalidentifier(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTierId(value);
      break;
    case 16:
      var value = /** @type {!proto.witbooking.loyalty.customer.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCommunicationConsent(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCreatedByBookAndJoin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthenticationServiceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEmailAddress();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBirthDate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      witbooking_backoffice_common_common_pb.Localizable.serializeBinaryToWriter
    );
  }
  f = message.getReferrer();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLoyaltyPoints();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getLegalidentifier();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTierId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getCommunicationConsent();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getCreatedByBookAndJoin();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string authentication_service_id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getAuthenticationServiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setAuthenticationServiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string brand_id = 3;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string last_name = 5;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string email_address = 6;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getEmailAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setEmailAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string phone_number = 7;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp birth_date = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getBirthDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
*/
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setBirthDate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.clearBirthDate = function() {
  return this.setBirthDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.hasBirthDate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional witbooking.backoffice.common.Localizable location = 9;
 * @return {?proto.witbooking.backoffice.common.Localizable}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getLocation = function() {
  return /** @type{?proto.witbooking.backoffice.common.Localizable} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Localizable, 9));
};


/**
 * @param {?proto.witbooking.backoffice.common.Localizable|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
*/
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string referrer = 10;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getReferrer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setReferrer = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 loyalty_points = 11;
 * @return {number}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getLoyaltyPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setLoyaltyPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string organization_id = 12;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated string tags = 13;
 * @return {!Array<string>}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional string legalIdentifier = 14;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getLegalidentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setLegalidentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string tier_id = 15;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getTierId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setTierId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional Status status = 16;
 * @return {!proto.witbooking.loyalty.customer.v1.Status}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getStatus = function() {
  return /** @type {!proto.witbooking.loyalty.customer.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.Status} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional bool communication_consent = 17;
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getCommunicationConsent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setCommunicationConsent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional string locale = 18;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional bool created_by_book_and_join = 19;
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.getCreatedByBookAndJoin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest.prototype.setCreatedByBookAndJoin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse;
  return proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customer: (f = msg.getCustomer()) && proto.witbooking.loyalty.customer.v1.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest;
  return proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.customer.v1.Customer;
      reader.readMessage(value,proto.witbooking.loyalty.customer.v1.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.customer.v1.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Customer customer = 1;
 * @return {?proto.witbooking.loyalty.customer.v1.Customer}
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.prototype.getCustomer = function() {
  return /** @type{?proto.witbooking.loyalty.customer.v1.Customer} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.customer.v1.Customer, 1));
};


/**
 * @param {?proto.witbooking.loyalty.customer.v1.Customer|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest} returns this
*/
proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse;
  return proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest;
  return proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    customer: (f = msg.getCustomer()) && proto.witbooking.loyalty.customer.v1.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse;
  return proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.customer.v1.Customer;
      reader.readMessage(value,proto.witbooking.loyalty.customer.v1.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.customer.v1.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Customer customer = 1;
 * @return {?proto.witbooking.loyalty.customer.v1.Customer}
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.prototype.getCustomer = function() {
  return /** @type{?proto.witbooking.loyalty.customer.v1.Customer} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.customer.v1.Customer, 1));
};


/**
 * @param {?proto.witbooking.loyalty.customer.v1.Customer|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse} returns this
*/
proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tierId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    referrer: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest;
  return proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTierId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferrer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTierId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReferrer();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string customer_id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tier_id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.prototype.getTierId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.prototype.setTierId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string referrer = 3;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.prototype.getReferrer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest.prototype.setReferrer = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    customer: (f = msg.getCustomer()) && proto.witbooking.loyalty.customer.v1.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse;
  return proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.customer.v1.Customer;
      reader.readMessage(value,proto.witbooking.loyalty.customer.v1.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.customer.v1.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Customer customer = 1;
 * @return {?proto.witbooking.loyalty.customer.v1.Customer}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.prototype.getCustomer = function() {
  return /** @type{?proto.witbooking.loyalty.customer.v1.Customer} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.customer.v1.Customer, 1));
};


/**
 * @param {?proto.witbooking.loyalty.customer.v1.Customer|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse} returns this
*/
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest;
  return proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.loyalty.customer.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string customer_id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Status status = 2;
 * @return {!proto.witbooking.loyalty.customer.v1.Status}
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.prototype.getStatus = function() {
  return /** @type {!proto.witbooking.loyalty.customer.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.Status} value
 * @return {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse;
  return proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest;
  return proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tierTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tierConditionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    expiresAt: (f = msg.getExpiresAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    info: (f = msg.getInfo()) && witbooking_loyalty_shared_tier_pb.TierConditionInfo.toObject(includeInstance, f),
    levelsList: jspb.Message.toObjectList(msg.getLevelsList(),
    witbooking_loyalty_shared_tier_pb.TierConditionLevel.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse;
  return proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTierTicker(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.loyalty.shared.TierConditionType} */ (reader.readEnum());
      msg.setTierConditionType(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiresAt(value);
      break;
    case 4:
      var value = new witbooking_loyalty_shared_tier_pb.TierConditionInfo;
      reader.readMessage(value,witbooking_loyalty_shared_tier_pb.TierConditionInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 5:
      var value = new witbooking_loyalty_shared_tier_pb.TierConditionLevel;
      reader.readMessage(value,witbooking_loyalty_shared_tier_pb.TierConditionLevel.deserializeBinaryFromReader);
      msg.addLevels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTierTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTierConditionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getExpiresAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      witbooking_loyalty_shared_tier_pb.TierConditionInfo.serializeBinaryToWriter
    );
  }
  f = message.getLevelsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      witbooking_loyalty_shared_tier_pb.TierConditionLevel.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tier_ticker = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.getTierTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.setTierTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional witbooking.loyalty.shared.TierConditionType tier_condition_type = 2;
 * @return {!proto.witbooking.loyalty.shared.TierConditionType}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.getTierConditionType = function() {
  return /** @type {!proto.witbooking.loyalty.shared.TierConditionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.loyalty.shared.TierConditionType} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.setTierConditionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp expires_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.getExpiresAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse} returns this
*/
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.setExpiresAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.clearExpiresAt = function() {
  return this.setExpiresAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.hasExpiresAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional witbooking.loyalty.shared.TierConditionInfo info = 4;
 * @return {?proto.witbooking.loyalty.shared.TierConditionInfo}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.getInfo = function() {
  return /** @type{?proto.witbooking.loyalty.shared.TierConditionInfo} */ (
    jspb.Message.getWrapperField(this, witbooking_loyalty_shared_tier_pb.TierConditionInfo, 4));
};


/**
 * @param {?proto.witbooking.loyalty.shared.TierConditionInfo|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse} returns this
*/
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated witbooking.loyalty.shared.TierConditionLevel levels = 5;
 * @return {!Array<!proto.witbooking.loyalty.shared.TierConditionLevel>}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.getLevelsList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.shared.TierConditionLevel>} */ (
    jspb.Message.getRepeatedWrapperField(this, witbooking_loyalty_shared_tier_pb.TierConditionLevel, 5));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.shared.TierConditionLevel>} value
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse} returns this
*/
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.setLevelsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.witbooking.loyalty.shared.TierConditionLevel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.shared.TierConditionLevel}
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.addLevels = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.witbooking.loyalty.shared.TierConditionLevel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.prototype.clearLevelsList = function() {
  return this.setLevelsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tierConditionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    amount: (f = msg.getAmount()) && witbooking_loyalty_shared_tier_pb.TierConditionAmount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest;
  return proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.loyalty.shared.TierConditionType} */ (reader.readEnum());
      msg.setTierConditionType(value);
      break;
    case 3:
      var value = new witbooking_loyalty_shared_tier_pb.TierConditionAmount;
      reader.readMessage(value,witbooking_loyalty_shared_tier_pb.TierConditionAmount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTierConditionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_loyalty_shared_tier_pb.TierConditionAmount.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional witbooking.loyalty.shared.TierConditionType tier_condition_type = 2;
 * @return {!proto.witbooking.loyalty.shared.TierConditionType}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.prototype.getTierConditionType = function() {
  return /** @type {!proto.witbooking.loyalty.shared.TierConditionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.loyalty.shared.TierConditionType} value
 * @return {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.prototype.setTierConditionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional witbooking.loyalty.shared.TierConditionAmount amount = 3;
 * @return {?proto.witbooking.loyalty.shared.TierConditionAmount}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.prototype.getAmount = function() {
  return /** @type{?proto.witbooking.loyalty.shared.TierConditionAmount} */ (
    jspb.Message.getWrapperField(this, witbooking_loyalty_shared_tier_pb.TierConditionAmount, 3));
};


/**
 * @param {?proto.witbooking.loyalty.shared.TierConditionAmount|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest} returns this
*/
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tierTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expiresAt: (f = msg.getExpiresAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse;
  return proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTierTicker(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTierTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpiresAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tier_ticker = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.prototype.getTierTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.prototype.setTierTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp expires_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.prototype.getExpiresAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse} returns this
*/
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.prototype.setExpiresAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse} returns this
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.prototype.clearExpiresAt = function() {
  return this.setExpiresAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.prototype.hasExpiresAt = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tierConditionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    amount: (f = msg.getAmount()) && witbooking_loyalty_shared_tier_pb.TierConditionAmount.toObject(includeInstance, f),
    validFrom: (f = msg.getValidFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest;
  return proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.loyalty.shared.TierConditionType} */ (reader.readEnum());
      msg.setTierConditionType(value);
      break;
    case 3:
      var value = new witbooking_loyalty_shared_tier_pb.TierConditionAmount;
      reader.readMessage(value,witbooking_loyalty_shared_tier_pb.TierConditionAmount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValidFrom(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTierConditionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_loyalty_shared_tier_pb.TierConditionAmount.serializeBinaryToWriter
    );
  }
  f = message.getValidFrom();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional witbooking.loyalty.shared.TierConditionType tier_condition_type = 2;
 * @return {!proto.witbooking.loyalty.shared.TierConditionType}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.getTierConditionType = function() {
  return /** @type {!proto.witbooking.loyalty.shared.TierConditionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.loyalty.shared.TierConditionType} value
 * @return {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.setTierConditionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional witbooking.loyalty.shared.TierConditionAmount amount = 3;
 * @return {?proto.witbooking.loyalty.shared.TierConditionAmount}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.getAmount = function() {
  return /** @type{?proto.witbooking.loyalty.shared.TierConditionAmount} */ (
    jspb.Message.getWrapperField(this, witbooking_loyalty_shared_tier_pb.TierConditionAmount, 3));
};


/**
 * @param {?proto.witbooking.loyalty.shared.TierConditionAmount|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} returns this
*/
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp valid_from = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.getValidFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} returns this
*/
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.setValidFrom = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.clearValidFrom = function() {
  return this.setValidFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest.prototype.hasValidFrom = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse;
  return proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    brandId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest;
  return proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest}
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brand_id = 3;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest} returns this
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse;
  return proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse}
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest}
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest;
  return proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest}
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse}
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse;
  return proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse}
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.customer.v1.Customer.repeatedFields_ = [16,17,23];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.Customer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.Customer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.Customer.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    authenticationServiceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    brandId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    emailAddress: jspb.Message.getFieldWithDefault(msg, 6, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
    birthDate: (f = msg.getBirthDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    location: (f = msg.getLocation()) && witbooking_backoffice_common_common_pb.Localizable.toObject(includeInstance, f),
    referrer: jspb.Message.getFieldWithDefault(msg, 10, ""),
    tierId: jspb.Message.getFieldWithDefault(msg, 11, ""),
    tierType: jspb.Message.getFieldWithDefault(msg, 12, 0),
    loyaltyPoints: jspb.Message.getFieldWithDefault(msg, 13, 0),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    organizationsList: jspb.Message.toObjectList(msg.getOrganizationsList(),
    proto.witbooking.loyalty.customer.v1.CustomerOrganization.toObject, includeInstance),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
    legalIdentifier: jspb.Message.getFieldWithDefault(msg, 18, ""),
    status: jspb.Message.getFieldWithDefault(msg, 19, 0),
    communicationConsent: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    locale: jspb.Message.getFieldWithDefault(msg, 21, ""),
    customerTransactionData: (f = msg.getCustomerTransactionData()) && proto.witbooking.loyalty.customer.v1.CustomerTransactionData.toObject(includeInstance, f),
    preferencesList: jspb.Message.toObjectList(msg.getPreferencesList(),
    proto.witbooking.loyalty.customer.v1.CustomerPreference.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.Customer}
 */
proto.witbooking.loyalty.customer.v1.Customer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.Customer;
  return proto.witbooking.loyalty.customer.v1.Customer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.Customer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.Customer}
 */
proto.witbooking.loyalty.customer.v1.Customer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthenticationServiceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailAddress(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBirthDate(value);
      break;
    case 9:
      var value = new witbooking_backoffice_common_common_pb.Localizable;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Localizable.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferrer(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTierId(value);
      break;
    case 12:
      var value = /** @type {!proto.witbooking.loyalty.customer.v1.TierType} */ (reader.readEnum());
      msg.setTierType(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLoyaltyPoints(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 16:
      var value = new proto.witbooking.loyalty.customer.v1.CustomerOrganization;
      reader.readMessage(value,proto.witbooking.loyalty.customer.v1.CustomerOrganization.deserializeBinaryFromReader);
      msg.addOrganizations(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegalIdentifier(value);
      break;
    case 19:
      var value = /** @type {!proto.witbooking.loyalty.customer.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCommunicationConsent(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 22:
      var value = new proto.witbooking.loyalty.customer.v1.CustomerTransactionData;
      reader.readMessage(value,proto.witbooking.loyalty.customer.v1.CustomerTransactionData.deserializeBinaryFromReader);
      msg.setCustomerTransactionData(value);
      break;
    case 23:
      var value = new proto.witbooking.loyalty.customer.v1.CustomerPreference;
      reader.readMessage(value,proto.witbooking.loyalty.customer.v1.CustomerPreference.deserializeBinaryFromReader);
      msg.addPreferences(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.Customer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.Customer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.Customer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthenticationServiceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEmailAddress();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBirthDate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      witbooking_backoffice_common_common_pb.Localizable.serializeBinaryToWriter
    );
  }
  f = message.getReferrer();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTierId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTierType();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getLoyaltyPoints();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOrganizationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.witbooking.loyalty.customer.v1.CustomerOrganization.serializeBinaryToWriter
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      17,
      f
    );
  }
  f = message.getLegalIdentifier();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getCommunicationConsent();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getCustomerTransactionData();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.witbooking.loyalty.customer.v1.CustomerTransactionData.serializeBinaryToWriter
    );
  }
  f = message.getPreferencesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      23,
      f,
      proto.witbooking.loyalty.customer.v1.CustomerPreference.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string authentication_service_id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getAuthenticationServiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setAuthenticationServiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string brand_id = 3;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string last_name = 5;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string email_address = 6;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getEmailAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setEmailAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string phone_number = 7;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp birth_date = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getBirthDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
*/
proto.witbooking.loyalty.customer.v1.Customer.prototype.setBirthDate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.clearBirthDate = function() {
  return this.setBirthDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.hasBirthDate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional witbooking.backoffice.common.Localizable location = 9;
 * @return {?proto.witbooking.backoffice.common.Localizable}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getLocation = function() {
  return /** @type{?proto.witbooking.backoffice.common.Localizable} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Localizable, 9));
};


/**
 * @param {?proto.witbooking.backoffice.common.Localizable|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
*/
proto.witbooking.loyalty.customer.v1.Customer.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string referrer = 10;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getReferrer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setReferrer = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string tier_id = 11;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getTierId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setTierId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional TierType tier_type = 12;
 * @return {!proto.witbooking.loyalty.customer.v1.TierType}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getTierType = function() {
  return /** @type {!proto.witbooking.loyalty.customer.v1.TierType} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.TierType} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setTierType = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional int32 loyalty_points = 13;
 * @return {number}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getLoyaltyPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setLoyaltyPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
*/
proto.witbooking.loyalty.customer.v1.Customer.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
*/
proto.witbooking.loyalty.customer.v1.Customer.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * repeated CustomerOrganization organizations = 16;
 * @return {!Array<!proto.witbooking.loyalty.customer.v1.CustomerOrganization>}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getOrganizationsList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.customer.v1.CustomerOrganization>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.loyalty.customer.v1.CustomerOrganization, 16));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.customer.v1.CustomerOrganization>} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
*/
proto.witbooking.loyalty.customer.v1.Customer.prototype.setOrganizationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerOrganization=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerOrganization}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.addOrganizations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.witbooking.loyalty.customer.v1.CustomerOrganization, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.clearOrganizationsList = function() {
  return this.setOrganizationsList([]);
};


/**
 * repeated string tags = 17;
 * @return {!Array<string>}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 17));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional string legal_identifier = 18;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getLegalIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setLegalIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional Status status = 19;
 * @return {!proto.witbooking.loyalty.customer.v1.Status}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getStatus = function() {
  return /** @type {!proto.witbooking.loyalty.customer.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.Status} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional bool communication_consent = 20;
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getCommunicationConsent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setCommunicationConsent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional string locale = 21;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional CustomerTransactionData customer_transaction_data = 22;
 * @return {?proto.witbooking.loyalty.customer.v1.CustomerTransactionData}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getCustomerTransactionData = function() {
  return /** @type{?proto.witbooking.loyalty.customer.v1.CustomerTransactionData} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.customer.v1.CustomerTransactionData, 22));
};


/**
 * @param {?proto.witbooking.loyalty.customer.v1.CustomerTransactionData|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
*/
proto.witbooking.loyalty.customer.v1.Customer.prototype.setCustomerTransactionData = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.clearCustomerTransactionData = function() {
  return this.setCustomerTransactionData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.hasCustomerTransactionData = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * repeated CustomerPreference preferences = 23;
 * @return {!Array<!proto.witbooking.loyalty.customer.v1.CustomerPreference>}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.getPreferencesList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.customer.v1.CustomerPreference>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.loyalty.customer.v1.CustomerPreference, 23));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.customer.v1.CustomerPreference>} value
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
*/
proto.witbooking.loyalty.customer.v1.Customer.prototype.setPreferencesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 23, value);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerPreference=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerPreference}
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.addPreferences = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 23, opt_value, proto.witbooking.loyalty.customer.v1.CustomerPreference, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.customer.v1.Customer} returns this
 */
proto.witbooking.loyalty.customer.v1.Customer.prototype.clearPreferencesList = function() {
  return this.setPreferencesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.CustomerOrganization.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerOrganization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    organizationType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerOrganization}
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.CustomerOrganization;
  return proto.witbooking.loyalty.customer.v1.CustomerOrganization.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerOrganization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerOrganization}
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = /** @type {!proto.witbooking.loyalty.customer.v1.OrganizationType} */ (reader.readEnum());
      msg.setOrganizationType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.CustomerOrganization.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerOrganization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrganizationType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerOrganization} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerOrganization} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional OrganizationType organization_type = 3;
 * @return {!proto.witbooking.loyalty.customer.v1.OrganizationType}
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.prototype.getOrganizationType = function() {
  return /** @type {!proto.witbooking.loyalty.customer.v1.OrganizationType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.OrganizationType} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerOrganization} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerOrganization.prototype.setOrganizationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.CustomerTransactionData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerTransactionData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.toObject = function(includeInstance, msg) {
  var f, obj = {
    pastTransactionsAmount: (f = msg.getPastTransactionsAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
    futureTransactionsAmount: (f = msg.getFutureTransactionsAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
    futureTransactions: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pastTransactions: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerTransactionData}
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.CustomerTransactionData;
  return proto.witbooking.loyalty.customer.v1.CustomerTransactionData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerTransactionData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerTransactionData}
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setPastTransactionsAmount(value);
      break;
    case 2:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setFutureTransactionsAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFutureTransactions(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPastTransactions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.CustomerTransactionData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerTransactionData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPastTransactionsAmount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getFutureTransactionsAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getFutureTransactions();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPastTransactions();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional google.type.Money past_transactions_amount = 1;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.getPastTransactionsAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 1));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerTransactionData} returns this
*/
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.setPastTransactionsAmount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerTransactionData} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.clearPastTransactionsAmount = function() {
  return this.setPastTransactionsAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.hasPastTransactionsAmount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.type.Money future_transactions_amount = 2;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.getFutureTransactionsAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 2));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerTransactionData} returns this
*/
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.setFutureTransactionsAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerTransactionData} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.clearFutureTransactionsAmount = function() {
  return this.setFutureTransactionsAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.hasFutureTransactionsAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 future_transactions = 3;
 * @return {number}
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.getFutureTransactions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerTransactionData} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.setFutureTransactions = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 past_transactions = 4;
 * @return {number}
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.getPastTransactions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerTransactionData} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerTransactionData.prototype.setPastTransactions = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.customer.v1.CustomerPreference.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.customer.v1.CustomerPreference.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerPreference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CustomerPreference.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerPreference}
 */
proto.witbooking.loyalty.customer.v1.CustomerPreference.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.customer.v1.CustomerPreference;
  return proto.witbooking.loyalty.customer.v1.CustomerPreference.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerPreference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerPreference}
 */
proto.witbooking.loyalty.customer.v1.CustomerPreference.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.customer.v1.CustomerPreference.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.customer.v1.CustomerPreference.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerPreference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.customer.v1.CustomerPreference.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerPreference.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerPreference} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerPreference.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.loyalty.customer.v1.CustomerPreference.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.customer.v1.CustomerPreference} returns this
 */
proto.witbooking.loyalty.customer.v1.CustomerPreference.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.witbooking.loyalty.customer.v1.TierType = {
  INVALID: 0,
  CONSTANT: 1,
  DERIVED: 2
};

/**
 * @enum {number}
 */
proto.witbooking.loyalty.customer.v1.OrganizationType = {
  INVALID_ORGANIZATION_TYPE: 0,
  COMPANY: 1,
  AGENCY: 2
};

/**
 * @enum {number}
 */
proto.witbooking.loyalty.customer.v1.Status = {
  INACTIVE: 0,
  ACTIVE: 1
};

goog.object.extend(exports, proto.witbooking.loyalty.customer.v1);
